import React from 'react';
import { store } from '../stores/mainStore';
import styled from 'styled-components';
import { i18n } from '../i18n';
import {Bkg, ButtonBar, Outline} from '../elements/Elements';
import {DarkPageModal, Popup, SpreadedContent} from '../elements/ModalElements';
import {B64Image, preloadImages} from './B64Image';
import {Content, Panel, PopupText, SimplePopup} from '../elements/TopBarElements';
import {Button} from '../elements/Buttons';
import {Well} from '../elements/LobbyItemElements';
import {motion} from 'framer-motion';
import {integration} from '../integration';

export const SkillzLegal = p => {
	return <SimplePopup top={0} h={108} 
		className = {p.className} backKey={p.backKey}
		box='assets/popups/panel.png' fullPath
		title='legal_title' titleTop={2} titleFS={6}
		clickX={() => {
			integration.postMixPanelEvent('settings_legal_close')
			store.showSkillzLegal = false
		}}
	>
		<LegalWell color='bronze' fs={3.2}>
			<div style={{fontSize: '4vw'}}>
				{i18n.t('Legal text big')}
			</div>
			{i18n.t('Legal text')}
		</LegalWell>
	</SimplePopup>
}
SkillzLegal.preloadImages = () => SimplePopup.preloadImages('assets/popups/panel.png');
const LegalWell = styled(Well)`
	margin: 8% 8% 8%;
    white-space: pre-wrap;
    position: relative;
    color: white;
    padding: 2%;
	height: 74%;
	flex-direction: column;
    justify-content: space-around;
`;

export const ServerError = p => {
	const onClose = () => {
		integration.postMixPanelEvent('server_error_restart')
		store.errorMessage = null;
		window.restartWebview();
	}
	return (
	<SimplePopup top={0} h={93} totalH={140}
		box='assets/popups/panel_short.png' fullPath
		title='server_error' titleTop={2.3} titleFS={5.5}
	>
		<SpreadContent h={68} t={8}>
			<PopupText fs={6}> {i18n.t('server_error_descr_1')} </PopupText>
			<PopupText fs={6}> {i18n.t('server_error_descr_2')} </PopupText>
			<Button w='40vw' color='blue' onClick={onClose} >
				{i18n.t('close')}
			</Button>
		</SpreadContent>
	</SimplePopup>
)}
ServerError.preloadImages = () => SimplePopup.preloadImages('assets/popups/panel_short.png');

export const ConnectionError = p => {
	return (
	<SimplePopup top={0} h={93} totalH={140}
		box='popup_box_connectionError.png'
	>
		<SpreadContent h={68} t={8}	onClick={p.onClick}/>
	</SimplePopup>
)}
ConnectionError.preloadImages = () => SimplePopup.preloadImages('popup_box_connectionError.png', true);

export const ResultHandExplain = styled(p => {
	return <SimplePopup top={0}
		className = {p.className} backKey={p.backKey}
		box='result_hand_rank_explanation.png'
		clickX={() => store.showResultHandExplain = false}
	/>
})`
	& ${Content} {
	    height: min(180vw, 85dvh);
		@media (min-aspect-ratio: 9 / 15) {
			transform: scale(1) !important;
		}
	}
	& ${Panel} {
	    height: min(180vw, 85dvh);
		width: min(90%, 43dvh);
		left: max(5%, calc(100% - 43dvh) / 2);
	}
`;
ResultHandExplain.preloadImages = () => SimplePopup.preloadImages('result_hand_rank_explanation.png', true);

export const MultiExplain = p => {
	return <SimplePopup top={0} h={129} 
		className = {p.className} backKey={p.backKey}
		box='assets/multiplier/popup_multiplier.png' fullPath
		title='multi_title' titleTop={2} titleFS={6}
		clickX={() => store.showMultiExplain = false}
	>
		<ExplainText fs={5.5}> {i18n.t('multi_descr')} </ExplainText>
	</SimplePopup>
}
MultiExplain.preloadImages = () => SimplePopup.preloadImages('assets/multiplier/popup_multiplier.png');
const ExplainText = styled(PopupText)`    margin: 8vw 10% 0;`;

export const SkillzRules = p => {
	const pages = ['',
		'how_to_play_panel_1.png',
		'how_to_play_panel_2.png',
		'how_to_play_panel_3.png',
		'how_to_play_panel_4.png',
		'how_to_play_panel_5.png'
	]
	const maxPages = pages.length-1;

	const inPhaserGame = store.activeMatch !== null;
	const onClose = (sendEvt = true) => {
		if(sendEvt && !inPhaserGame)
			integration.postMixPanelEvent(`ftue_${store.showSkillzRules}_closed`)
		if(inPhaserGame)
			integration.postMixPanelEvent('settings_howtoplay_close')
		store.showSkillzRules = 0;

		if(!store.activeMatch) {
			window.setPersistentStorage('rules_viewed', true);
			store.modal = 'stakeSelect';
		}

	}
	const onPlay = () => {
		window.manager.playAudio('poopPop');
		if(!inPhaserGame)
			integration.postMixPanelEvent('ftue_lets_play')
		onClose(false);
	}
	const decrease = () => {
		window.manager.playAudio('SFX_UI_Click');
		store.showSkillzRules = Math.max(1, store.showSkillzRules-1);
	}
	const increase = () => {
		window.manager.playAudio('SFX_UI_Click');
		if(!inPhaserGame)
			integration.postMixPanelEvent(`ftue_${store.showSkillzRules}_pressed`)
		store.showSkillzRules = Math.min(store.showSkillzRules + 1, maxPages)
	}

	if(!inPhaserGame)
		integration.postMixPanelEvent(`ftue_${store.showSkillzRules}_shown`)

	const xPos = i => (150 - 200*i)+'vw';
	return <RulesPopup top={0} h={149} backKey={p.backKey}
		box={'assets/languages/en/'+pages[store.showSkillzRules]} fullPath
		clickX={onClose} xRight={0} xTop={-1}
	>
		<RulesPages
			initial={{x: xPos(1)}} animate={{x: xPos(store.showSkillzRules)}}
			transition={{duration: 0.25}}
		>
			{pages.filter(Boolean).map(
				(pic, i) => <div key={'htp'+i}>
					<B64Image 	alt={'htp'+i}
						src={'assets/languages/en/'+pic} 
					/>
				</div>
			)}
		</RulesPages>
		<RulesControls>

			{(store.showSkillzRules === maxPages) ? 
				<Button h="6vw" w='60vw' color='green' 
					//disable={this.btnClicked}
					onClick={onPlay} 
				>
					{i18n.t('lets_play')}
				</Button>
			: <>
				<Arrow left 
					onClick={decrease}
					disable={store.showSkillzRules === 1}
				/>
				{pages.filter(Boolean).map((_v, i) => <Dot glow={store.showSkillzRules === i+1} key={`dot${i}`}/>)}
				<Arrow right 
					onClick={increase}
					disable={store.showSkillzRules === maxPages}
				/>			
			</>}
		</RulesControls>	
	</RulesPopup>
}
SkillzRules.preloadImages = () => {
	return Promise.all([
		RulesPopup.preloadImages('how_to_play_panel_1.png'),
		RulesPopup.preloadImages('how_to_play_panel_2.png'),
		RulesPopup.preloadImages('how_to_play_panel_3.png'),
		RulesPopup.preloadImages('how_to_play_panel_4.png'),
		RulesPopup.preloadImages('how_to_play_panel_5.png'),
		Arrow.preloadImages(),
		Dot.preloadImages()
	])
}

const RulesPages = styled(motion.div)`
	position: relative;
	display: flex;
	& > div {	
		flex: 1 0 200vw;
		& > img {	width: 100vw;}
	}
`;

const RulesPopup = styled(SimplePopup)`
	${Content} { top: 5vh;}
	${Panel} { 
		width: 100vw; left: 0;
		& > ${Bkg} {opacity: 0;}
	}
`;
RulesPopup.preloadImages = box => SimplePopup.preloadImages(box, true);

const RulesControls = styled.div`
	position: relative;
	//top: 135vw;
	bottom: 15vw;
	display: flex;
	justify-content: center;
	height: 12vw;
	align-items: center;
`;
const Dot = styled(p => { return (
	<B64Image  className={p.className} 
		src={`assets/ftue_tour_msg_dot_${p.glow ? 'on' : 'off'}.png`}
	/>
)})`
	position:relative;
	width: 4vw;
	height: 4vw;
	margin: 0 2vw;
`;
Dot.preloadImages = () => preloadImages([
	'assets/ftue_tour_msg_dot_on.png',
	'assets/ftue_tour_msg_dot_off.png'
]);

const Arrow = styled(p => { return (
	<B64Image className={p.className} 
		src="assets/arrow_white.png" 
		onClick={p.onClick}
	/>
)})`
	flex: 0 0 7vw;
	width: 5vw;
	margin: 0 3vw;
	transform: rotate(${p => p.left ? 90 : -90}deg) scaleX(1.5) scaleY(1);
	opacity: ${p => p.disable ? 0.5 : 1};
	cursor: ${p => p.disable ? 'initial' : 'pointer'};
	pointer-events: ${p => p.disable ? 'none' : 'inherit'};
`;
Arrow.preloadImages = () => preloadImages(['assets/arrow_white.png']);

export const SkillzNotificationsDeviceSettings = p => {
	const skip = () => {
		window.manager.playAudio('poopPop');
		store.modal = '';
		store.showSkillzSettings = 'settings';
	}

	const ok = () => {
		window.manager.playAudio('poopPop');
		window.WrapperApp.postMessage("notifcations-settings");
		store.modal = '';
	};
	const state = store.settings.notifications ? 'on' : 'off';

	return <DarkPageModal>
		<Popup h={124} bkg={'box_pushNotification_deviceSettings_' + state} >
			<SpreadContent h={19} t={16}>
				<Outline textKey={'skillz_notif_' + state}/>
			</SpreadContent>
			<SpreadContent h={35} t={41}>
				<Outline textKey='skillz_notif_bottom'/>
				<ButtonBar>
					<Button w='32vw' color='grey' onClick={skip} >
						{i18n.t('skip')}
					</Button>
					<Button w='32vw' color='blue' onClick={ok} >
						{i18n.t('okay')}
					</Button>
				</ButtonBar>
			</SpreadContent>
		</Popup>
	</DarkPageModal>
}
const SpreadContent = styled(SpreadedContent)`
	width: 85%;
	font-size: 4.8vw;
	justify-content: space-around;
`;
